// issueInvoice.js

import { buildNodeFieldPatch } from 'utilities/NodeFieldData';
import { updateNode } from 'services/nodes/NodeWriteService';
import { enqueueInvoiceQboSync } from 'services/quickbooks/QuickBooksService';
import { INVOICE_TYPE_KEY } from 'nodetypes/invoice/view/invoiceGeneralInfoModel';
import {
  isInvoiceIssued,
  isInvoiceVoided,
} from 'nodetypes/invoice/lifecycle/invoiceLifecycleModel';

/**
 * Finalize an invoice (Issue lock). Does not set documentStatus: sent.
 *
 * @param {object} options
 * @param {object} options.invoiceNode
 * @param {object|null} [options.invoiceType]
 * @returns {Promise<object>} Applied patch
 */
export async function issueInvoice({
  invoiceNode,
  invoiceType = null,
}) {
  if (!invoiceNode?.key) {
    throw new Error('Invoice is required to issue.');
  }
  if (isInvoiceVoided(invoiceNode, invoiceType)) {
    throw new Error('A voided invoice cannot be issued.');
  }
  if (isInvoiceIssued(invoiceNode, invoiceType)) {
    return {};
  }

  const issuedAt = new Date().toISOString();
  const patch = buildNodeFieldPatch(
    invoiceNode,
    { name: 'issuedAt', source: 'invoice', type: 'datetime' },
    INVOICE_TYPE_KEY,
    issuedAt,
  );
  if (!patch) {
    throw new Error('Could not write issuedAt on invoice.');
  }
  await updateNode(invoiceNode.key, patch);
  enqueueInvoiceQboSync({
    invoiceNode,
    reason: 'issue',
  });
  return patch;
}
